import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";

function Section({ title, children }: Props) {
  return (
    <div className={styles.section}>
      <div className={styles.heading}>
        <h1 className={styles.title}>{title}</h1>
      </div>
      <div className={styles.main}>{children}</div>
    </div>
  );
}

export { Section };
